//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getUpgradeList as _getUpgradeList, getUpgradeKey as _getUpgradeKey, getUpgradeLog as _getUpgradeLog, getUpgradeAgreement as _getUpgradeAgreement, getUpgradeStart as _getUpgradeStart, getUpgradeProgress as _getUpgradeProgress } from '@/api/setting.js';
import { logout } from '@/api//user.js';
import { version } from '@/api/setting';
export default {
  name: '',
  data: function data() {
    return {
      activeName: 'first',
      activities: [],
      logActivities: [],
      agreemen: {},
      activeNames: 0,
      info: {},
      arrId: [],
      status: false,
      version: '',
      exoneration: false,
      upgrade: false,
      infoUpgrade: '',
      upgradeProgress: {
        speed: 0
      },
      isActive: 2,
      timer: null,
      downloadStatus: null,
      one: 0
    };
  },
  computed: {},
  watch: {
    // 'upgradeProgress.speed': {
    //   handler(newVal, oldVal) {
    //     if (newVal == '100.0') {
    //       clearInterval(this.timer);
    //     }
    //   },
    // },
  },
  created: function created() {},
  mounted: function mounted() {
    this.getUpgradeList();
    this.getUpgradeKey();
    this.getVersion();
    this.getUpgradeAgreement();
  },
  methods: {
    //   获取在线升级列表
    getUpgradeList: function getUpgradeList() {
      var _this = this;
      _getUpgradeList().then(function (res) {
        _this.activities = res.data.list;
      });
    },
    // 获取版本号
    getVersion: function getVersion() {
      var _this2 = this;
      version().then(function (res) {
        _this2.version = res.data.version;
      });
    },
    handleChange: function handleChange(val) {
      if (val.length == 0) {
        this.isActive = 1;
      } else {
        this.isActive = 2;
      }
    },
    // 获取在线升级数据
    getUpgradeKey: function getUpgradeKey() {
      var _this3 = this;
      _getUpgradeKey().then(function (res) {
        _this3.info = res.data;
        _this3.infoUpgrade = _this3.info.first_version + '.' + _this3.info.second_version + '.' + _this3.info.third_version;
        if (res.status == 200) {
          _this3.status = true;
        } else {
          _this3.status = false;
        }
      });
    },
    // 获取升级协议
    getUpgradeAgreement: function getUpgradeAgreement() {
      var _this4 = this;
      _getUpgradeAgreement().then(function (res) {
        _this4.agreemen = res.data;
      });
    },
    // 获取升级日志
    getUpgradeLog: function getUpgradeLog() {
      var _this5 = this;
      _getUpgradeLog().then(function (res) {
        _this5.logActivities = res.data.list;
      });
    },
    // 关闭协议弹窗
    refuse: function refuse() {
      this.exoneration = false;
    },
    // 同意协议
    agree: function agree() {
      this.exoneration = false;
      this.upgrade = true;
      this.format();
      this.getUpgradeStart();
    },
    // 点击立即升级
    update: function update() {
      this.exoneration = true;
    },
    //  开始升级
    getUpgradeStart: function getUpgradeStart() {
      var _this6 = this;
      _getUpgradeStart(this.info.package_key).then(function (res) {
        if (res.status == 200) {
          _this6.timer = setInterval(function () {
            _this6.getUpgradeProgress();
          }, 4000);
        }
      }).catch(function (err) {
        _this6.$message.error('下载终止');
        clearInterval(_this6.timer);
        _this6.timer = null;
        _this6.upgrade = false;
      });
    },
    // 升级完毕确认并退出登录
    back: function back() {
      var _this7 = this;
      this.upgrade = false;
      logout().then(function (res) {
        _this7.$message.success('您已成功升级，系统将自动退出，请您重新登录');
        _this7.$router.replace('/admin/login');
        localStorage.clear();
        removeCookies('token');
        removeCookies('expires_time');
        removeCookies('uuid');
      }).catch(function (res) {});
    },
    format: function format() {
      // let text = '升级中！';
      return this.upgradeProgress.tip || '升级中' + '\n';
    },
    judgeActive: function judgeActive(val) {
      this.activeNames = val;
    },
    // 获取升级进度
    getUpgradeProgress: function getUpgradeProgress() {
      var _this8 = this;
      _getUpgradeProgress().then(function (res) {
        _this8.upgradeProgress = res.data;
        _this8.downloadStatus = res.status;
        if (_this8.upgradeProgress.speed == '100.0') {
          clearInterval(_this8.timer);
          _this8.timer = null;
        }
      }).catch(function (err) {
        clearInterval(_this8.timer);
        _this8.upgrade = false;
      });
    },
    // 切换tab栏
    handleClick: function handleClick() {
      if (this.activeName == 'first') {
        this.getUpgradeList();
      } else {
        this.activeNames = 0;
        this.isActive = 2;
        this.getUpgradeLog();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    //销毁
    clearInterval(this.timer);
    this.timer = null;
  }
};